export const expdata = [
   {
    id: 1,
    date: "June 2026 to present",
    position:"Assistant Professor CSE(AIML)",
    company:"PES University Bangalore",
    skills:"Assistant Professor CSE(AIML) ",
    about:"Assistant professor computer Science and Engineering"
  },
  {
    id: 2,
    date: "Feb 2024 to present",
    position:"Assistant Professor CSE",
    company:"Jain University Bangalore",
    skills:"Assistant Professor CSE, ERP Coordinator,NBA PFile Handler ",
    about:"Assistant professor computer Science and Engineering"
  },
  {
    id: 3,
    date: "Dec 2023 to present",
    position:"Part Time Content Developer,Assistant Professor",
    company:"Britts Imperial University",
    skills:"Content Developer, Professor CSE, Video Creator ",
    about:"Assistant professor computer Science and Engineering (Part Time)"
  },  
  {

      id: 4,
      date: "Jan (2022) to Dec 2023",
      position:"Assistant Professor CSE",
      company:"Lovely Professional University",
      skills:"Front end development, ML ,Data Managment & visualisation,Java",
      about:"Assistant professor computer Science and Engineering with expertise in Machine learning and web development"
    },
    {
        id:5,
        date: "Jan (2021) - jan (2022)",
        position:"Assistant Professor CSE",
        company:"PCTE Group of Institutes Ludhiana",
        skills:"Software Engineering, Cloud computing and AI",
        about:`Assistant professor computer Science and Engineering Courses taught Software Engineering,Cloud computing,AI and Web Designing`
      },
      {
        id: 6,
        date: "Aug 2017-Aug(2018)",
        position:"Software Developer cum Trainer",
        company:"Momin Technologies",
        skills:"HTML,CSS,JS,MVC",
        about:"Software developer cum technical support engineer"
      }
      
  ]
    